var React = require('react');

function RedGemini (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.7917,18.5175v-8.6424c.7325.1079,1.475.1695,2.2247.1695.873,0,1.7343-.0798,2.5792-.2221v8.655c-.7452-.1115-1.5013-.1759-2.2646-.1759-.8594,0-1.7071.078-2.5393.2158h0ZM20.2219,19.4821v-10.742c2.6399-1.1577,4.9444-3.0434,6.6098-5.5092l-3.0044-2.0298c-2.2075,3.2664-5.8746,5.2173-9.8109,5.2173-3.7686,0-7.3451-1.8213-9.568-4.8719L1.5175,3.6815c1.7062,2.3426,4.027,4.124,6.6479,5.1992v10.7084c-2.6563,1.1559-4.9762,3.0488-6.6506,5.5265l3.0053,2.0298c2.2066-3.2664,5.8746-5.2173,9.8109-5.2173,3.7686,0,7.3451,1.8222,9.5689,4.8728l2.93-2.135c-1.698-2.3308-4.0034-4.1068-6.608-5.1838Z","fill":"#fdddd2","strokeWidth":"0"}));
}

RedGemini.defaultProps = {"id":"Layer_1","data-name":"Layer 1","version":"1.1","viewBox":"0 0 28.3465 28.3465"};

module.exports = RedGemini;

RedGemini.default = RedGemini;
